import firebase from "./FirebaseService";

class RequestService {
	
	async createRequest(name, email, age, plan, instagram, country, whatsapp, description) {
		if(name.length === 0 || email.length === 0 || age.length === 0 || plan.length === 0) {
			return new Error("You need to fill the required fields");
		}
		else {
			try {
				await firebase.firestore().collection("requests").add({
					name: name,
					email: email,
					age: age,
					plan: plan,
					description: description,
					country: country,
					instagram: instagram,
					whatsapp: whatsapp,
					date: new Date()
				});
			}
			catch(error) {
				throw error;
			}
		}
	}
	async getRequests() {

		try {

			const results = await firebase.firestore().collection("requests").orderBy("date", "desc").get();
			const docs = results.docs;

			let requests = [];
		
			for(let i = 0; i < docs.length; i++) {

				requests.push({
					id: docs[i].id,
					name: docs[i].get("name"),
					email: docs[i].get("email"),
					age: docs[i].get("age"),
					plan: docs[i].get("plan"),
					instagram: docs[i].get("instagram"),
					country: docs[i].get("country"),
					whatsapp: docs[i].get("whatsapp"),
					description: docs[i].get("description"),
					date: docs[i].get("date").toDate()
				});
			}
			
			return requests;
		
		}
		catch(error) {
			throw new Error("An error has occured, please try again later");
		}
	}
	async deleteRequest(id) {

		try {

			await firebase.firestore().collection("requests").doc(id).delete();
		
		}
		catch(error) {
			throw new Error("An error has occured, please try again later");
		}
	}
}

export default RequestService;